module.exports = __webpack_public_path__ + "static/media/used5.083aef63.JPG";